/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Video_UnsupportedInputs */

const en_us2_share_video_unsupported = /** @type {(inputs: Share_Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This device can't make video. The story image goes instead.`)
};

const pt_br2_share_video_unsupported = /** @type {(inputs: Share_Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este aparelho não gera vídeo. A imagem dos stories vai no lugar.`)
};

const es_419_share_video_unsupported = /** @type {(inputs: Share_Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este dispositivo no puede generar video. Se comparte la imagen de historias en su lugar.`)
};

const pt_pt2_share_video_unsupported = /** @type {(inputs: Share_Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este dispositivo não gera vídeo. Vai a imagem das stories em vez disso.`)
};

const fr_fr2_share_video_unsupported = /** @type {(inputs: Share_Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet appareil ne peut pas créer de vidéo. L'image story sera partagée à la place.`)
};

const de_de2_share_video_unsupported = /** @type {(inputs: Share_Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Gerät kann kein Video erstellen. Stattdessen wird das Story-Bild verwendet.`)
};

const it_it2_share_video_unsupported = /** @type {(inputs: Share_Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo dispositivo non può creare video. Al suo posto va l'immagine per le storie.`)
};

/**
* | output |
* | --- |
* | "This device can't make video. The story image goes instead." |
*
* @param {Share_Video_UnsupportedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_video_unsupported = /** @type {((inputs?: Share_Video_UnsupportedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Video_UnsupportedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_video_unsupported(inputs)
	if (locale === "es-419") return es_419_share_video_unsupported(inputs)
	if (locale === "pt-PT") return pt_pt2_share_video_unsupported(inputs)
	if (locale === "fr-FR") return fr_fr2_share_video_unsupported(inputs)
	if (locale === "de-DE") return de_de2_share_video_unsupported(inputs)
	if (locale === "it-IT") return it_it2_share_video_unsupported(inputs)
	return en_us2_share_video_unsupported(inputs)
});
export { share_video_unsupported as "share.video_unsupported" }